/** biome-ignore-all lint/style/noNonNullAssertion: params are checked in enabled */
import type { UseQueryOptions } from '@tanstack/react-query';
import { graphHopperApi } from '@/shared/api';
import type { LatLng } from '@/shared/types';
import { directionKeys } from './direction.keys';
import { parseRouteSummary, type RouteSummary } from './routeSummary.schema';

export const graphHopperDirectionQueryOption = (
	routeId: string,
	origin?: LatLng | null,
	destination?: LatLng | null,
): UseQueryOptions<RouteSummary | null> => ({
	queryFn: async () => {
		const response = await graphHopperApi.getDirection({
			origin: origin!,
			destination: destination!,
		});

		const path = response.paths[0];
		const result = parseRouteSummary({
			distance: path.distance,
			duration: path.time,
		});

		if (result.isErr()) {
			return null;
		}

		return result.value;
	},
	queryKey: directionKeys.graphHopper(routeId, origin, destination),
	enabled: !!routeId && !!origin && !!destination,
	staleTime: Infinity,
	gcTime: Infinity,
});
